<template>

    <div class="flex flex-grow">


        <div class="flex flex-grow flex-col" v-if="hasTags">

            <div class="flex-grow justify-between grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-12"
                v-if="videolist.length > 0">
                <div class="relative group" v-for="(video, index) in videolist" :key="'videocont_' + video.id">

                    <video-item :the_video="video" :key="'video_' + video.id + '_' + video.grantaccess"
                        :teamtags="teamtags" :datacenter="datacenter" :selectMode="selectMode"
                        @click="selectVideo(video)" :way="way" />


                    <div
                        :class="[selectMode ? 'opacity-100' : 'opacity-0', 'absolute top-2 left-3 opacity-0 group-hover:opacity-100 transition-opacity z-10']">
                        <input id="select" name="select" type="checkbox" v-model="video.selected"
                            @change="selectedVideo(video)"
                            class="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white
                            checked:!bg-gray-900 indeterminate:border-gray-900 indeterminate:bg-gray-900
                            focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900
                            disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100
                            forced-colors:appearance-auto
                            checked:outline checked:outline-2 checked:outline-offset-2 checked:outline-gray-900 checked:border-gray-300 checked:ring-1 checked:ring-offset-1 checked:ring-white"
                            style="accent-color: #111827;" />
                    </div>

                    <div v-if="way == 'unified_personals' && false" class=" w-full -mt-0.5 text-gray-500 flex items-center text-xs px-4
                        gap-x-2">
                        <FolderIcon class="size-3 flex-shrink-0" /><span class="truncate">{{ whereAmI(video) }}</span>
                    </div>

                </div>
            </div>

            <p class="mt-20 pt-5 text-center text-gray-500" v-else-if="!isInit && way == 'my'">
                <jet-secondary-button v-if="!extension_loaded" class="min-w-80  justify-center"
                    @click="skipToExtension()">
                    Install Free Extension
                </jet-secondary-button>
                <jet-secondary-button v-else class="min-w-80  justify-center" @click="startRecording()">
                    Make your first recording
                </jet-secondary-button>
            </p>
            <p class="mt-5 pt-5 text-center text-gray-500" v-else-if="!isInit">No video found…</p>


            <infinite-loading @infinite="infiniteHandler">
                <template #spinner>
                    <spinner v-if="false" class="mx-auto h-8 w-8 text-gray-400 mt-20"></spinner>

                    <div v-if="isInit"
                        class="flex-grow justify-between grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12">
                        <video-skeleton />
                        <video-skeleton />
                        <video-skeleton />
                    </div>
                    <div class="flex-grow justify-between grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 mt-8">
                        <video-skeleton />
                        <video-skeleton />
                        <video-skeleton />
                    </div>
                    <div v-if="isInit"
                        class="flex-grow justify-between grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 mt-8">
                        <video-skeleton />
                        <video-skeleton />
                        <video-skeleton />
                    </div>


                </template>
                <template #no-more>
                    <div class="text-gray-400 text-center text-sm my-20" v-show="videolist.length > 0">No more videos
                        here!
                    </div>
                </template>
                <template #no-results>
                    <div class="text-secondary"></div>
                </template>
            </infinite-loading>

        </div>

    </div>

    <!-- <b-toast id="toast" title="" no-close-button auto-hide-delay="3700" toaster="b-toaster-top-center" variant="primary" :append-toast="true">
      <template v-slot:default>
		    <div v-on:click="toastClose">{{ toast_message }}</div>
		  </template>
	  </b-toast> -->



</template>



<script>


import VideoItem from './VideoItem.vue'
import InfiniteLoading from "infinite-loading-vue3-ts"
import Spinner from '@/Components/UI/Spinner'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import VideoSkeleton from '@/Components/UI/VideoSkeleton'
import { FolderIcon } from "@heroicons/vue/20/solid";

export default {

    props: ['way', 'search', 'datacenter', 'currentFolder'],

    components: {
        VideoItem,
        InfiniteLoading, VideoSkeleton,
        Spinner, JetSecondaryButton, FolderIcon
    },

    created: function () {
        this.EventBus.on('toast', (message) => {
            this.toastShow(message);
        });
        this.EventBus.on('refreshTags', (new_taglist) => {
            this.teamtags = new_taglist;
            //console.log("refreshTags")
            //this.fetchTags();
        });

        this.extension_loaded = window.extension_loaded || false;
        document.addEventListener('EXTENSION_RESPONSE', this.extension_loaded_listener);

    },

    beforeUnmount() {
        document.removeEventListener('EXTENSION_RESPONSE', this.extension_loaded_listener);
        this.EventBus.off('toast');
        this.EventBus.off('refreshTags');
    },

    data() {
        return {
            toast_message: '',
            videolist: {},
            isInit: true,
            page: 1,
            lastPage: 0,
            hasTags: false,
            teamtags: {},
            extension_loaded: window.extension_loaded,
        }
    },

    mounted: function () {
        //this.reloadVideos();
        //console.log(moment.tz.guess());
        //console.log(this.videolist.length == 0);
        this.extension_loaded = window.extension_loaded;
        this.fetchTags();
    },

    methods: {
        whereAmI(video) {
            let where = ""
            if (video.mine) {
                where += "Personal"
            } else {
                where += "Team"
            }
            if (video.folder) {
                where += " / " + video.folder.name
            }
            return where
        },
        extension_loaded_listener(event) {
            this.extension_loaded = true;
            window.extension_loaded = true;
        },
        unselectAllVideos() {
            this.videolist.forEach(video => {
                video.selected = false;
            });
        },
        selectedVideo(video) {
            if (video.selected) {
                this.$parent.addSelectedVideos(video)
            } else {
                this.$parent.removeSelectedVideos(video)
            }
        },
        selectVideo(video) {
            if (this.selectMode) {
                video.selected = !video.selected;
                if (video.selected) {
                    this.$parent.addSelectedVideos(video)
                } else {
                    this.$parent.removeSelectedVideos(video)
                }
            }
        },
        startRecording() {
            document.dispatchEvent(new CustomEvent('START_RECORDING_ASKED', {
                detail: {}
            }));
        },
        skipToExtension() {
            window.location.href = "https://chromewebstore.google.com/detail/birdie/glkfmfjeafnooojgeobbhdjhdejocoap"
        },
        fetchTags: function () {
            var url = this.$page.props.api_url + '/v1/tag';
            axios.get(url)
                .then(response => {
                    //console.log(response.data);
                    this.teamtags = response.data;
                    this.hasTags = true;
                    //this.infiniteHandler()
                })
                .catch(e => {
                    console.error(e);
                });
        },
        toastShow: function (message) {
            this.toast_message = message;
            this.$bvToast.show('toast');
        },
        toastClose: function () {
            this.$bvToast.hide('toast');
        },
        removeVideos: function (removed_ids) {
            var newVideos = [];
            for (const video of this.videolist) {
                if (removed_ids.includes(video.id)) {
                    continue;
                }
                newVideos.push(video);
            }
            this.videolist = newVideos.slice();
            if (this.videolist.length == 0 && !this.isInit) {
                this.$inertia.reload();
            }
        },
        fetchFeedback: function () {
            var url = this.$page.props.api_url + '/v1/videos/incoming';
            var qparams = {}

            if (this.way == 'unified_personals') {
                url = this.$page.props.api_url + '/v1/videos/unified_personals';
            } else if (this.way == 'sent') {
                url = this.$page.props.api_url + '/v1/videos/outgoing';
            } else if (this.way == 'my') {
                url = this.$page.props.api_url + '/v1/videos/personal';
            } else if (this.way == 'search') {
                url = this.$page.props.api_url + '/v1/videos/search';
                if (this.search) {
                    let search = JSON.parse(this.search);
                    if (search.video) {
                        qparams.video = search.video.trim();
                    }
                    if (search.tag) {
                        qparams.tag = search.tag.trim();
                    }
                    if (search.contact) {
                        qparams.contact = search.contact.trim();
                    }
                    if (search.user) {
                        qparams.user = search.user.trim();
                    }
                    if (search.q) {
                        qparams.q = search.q.trim();
                    }
                }
            }
            if (this.isInit === false) {
                //url += `?page=${this.page}`
                qparams.page = this.page;
            }
            if (this.currentFolder && this.currentFolder.id) {
                qparams.folder_id = this.currentFolder.id;
            }
            //console.log(qparams);
            return axios.get(url, { params: qparams });
        },
        infiniteHandler: function ($state = null) {
            if (!this.hasTags) {
                return
            }

            let delay = this.isInit ? 10 : 1000;
            //console.log("infiniteHandler page", this.page)
            setTimeout(function () {
                this.fetchFeedback()
                    .then(response => {
                        //console.log(response.data);
                        if (response.data.data.length > 0) {
                            this.lastPage = response.data.last_page;
                            if (this.isInit) {
                                this.videolist = response.data.data;
                                this.isInit = false;
                            } else {
                                response.data.data.forEach(video => {

                                    this.videolist.push(video);
                                });
                            }
                            if (response.data.last_page == response.data.current_page) {
                                this.page = response.data.current_page;
                                if ($state) {
                                    $state.complete();
                                }
                                return
                            } else if (this.page - 1 === this.lastPage) {
                                this.page = 2;
                                if ($state) {
                                    $state.complete();
                                }
                                return
                            } else {
                                this.page += 1;
                            }
                            setTimeout(function () {
                                if ($state) {
                                    $state.loaded();
                                }
                            }, 400)

                        } else {
                            this.isInit = false;
                            this.page = 2;
                            if ($state) {
                                $state.complete();
                            }
                        }
                    })
                    .catch(e => console.error(e));
            }.bind(this), delay);
        }
    },

    computed: {
        selectMode: function () {
            return this.videolist.some(video => video.selected);
        }
    }
}

</script>

<style scoped>
.thatsall {
    opacity: 0.6;
}
</style>
